import { Directive, ElementRef, Input, OnInit, HostListener } from '@angular/core';

@Directive({
	selector: '[ttFixedTableHeader]'
})

export class FixedTableHeaderDirective implements OnInit {
	private table: any;
	private headerRows: any;
	private fakeHeaderRow: any;
	private readonly topPanelHeight: number = 50;
	private topLimit: number = 85;
	private element: any;

	@HostListener('window:resize')
	onResize(): void {
		this.resizeHeader();
	}

	constructor(el: ElementRef) {
		this.element = el;
	}

	ngOnInit(): void {
		const e: HTMLElement = this.element.nativeElement;
		this.table = e.parentElement;
		this.topLimit = this.table.className.search('holidays-table') === -1 ? this.topLimit : 121;
		this.headerRows = e.querySelectorAll('tr');
		this.fakeHeaderRow = e.parentElement.querySelector('tr.fake-header');
		e.style['visibility'] = 'hidden';
		e.style['position'] = 'fixed';
		e.parentElement.onclick = this.resizeHeader.bind(this);

		window.onscroll = ((): void => {
			this.resizeHeader();
			window.onscroll = this.onScroll.bind(this);
			this.onScroll();
		}).bind(this);
	}

	private onScroll(): void {
		if (window.pageYOffset > this.topLimit) {
			this.element.nativeElement.style['margin-top'] = (-1 * this.topLimit) + 'px';
			this.element.nativeElement.style['visibility'] = '';
		} else {
			this.element.nativeElement.style['visibility'] = 'hidden';
			this.element.nativeElement.style['margin-top'] = 0;
		}
	}

	private resizeHeader(): void {
		const arr: any[] = this.fakeHeaderRow.querySelectorAll('th,td') || [];
		for (let index: number = 0; index < arr.length; ++index) {
			const cellWidth: number = arr[index].offsetWidth;
			this.headerRows.forEach((row: any) => {
				row.querySelectorAll('th, td')[index].style.width = cellWidth + 'px';
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/fixed-table-header.directive.ts